import {Component, OnInit, Output, EventEmitter, Input, Inject} from '@angular/core';
import {BreakpointService} from '../../../shared/services/breakpoint.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {ProgressService} from '../../services/progress.service';
import {MsalService} from '@azure/msal-angular';
import {Disposable} from '../../../shared/extensions/disposable';
import {UserProfileService} from '../../../auth/services/user-profile.service';
import {ENV_CONFIG, EnvConfig} from '../../../../configuration';
import {UserProfile} from '../../../auth/common/user-profile';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map, mergeMap, take, takeUntil} from 'rxjs/operators';
import {Authorize, authorizeMap} from '../../../auth/common/authorize-map';
import {UserClient} from '../../../shared/apis/api.client';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends Disposable implements OnInit {
    @Output() expandSideMenuClick = new EventEmitter<void>();
    @Input() sideNavVisible = true;
    public isHandSet$: Observable<boolean>;
    public isLoading$: Observable<boolean>;
    isIframe = false;
    public userProfile$: Observable<UserProfile>;
    public showCaseActions = false;
    public canAddCase = authorizeMap[Authorize.CreateCase].roles;

    constructor(
        private breakpointService: BreakpointService,
        private progress: ProgressService,
        private profileService: UserProfileService,
        private authService: MsalService,
        @Inject(ENV_CONFIG) private readonly envConfig: EnvConfig,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userProfileService: UserProfileService,
        private userClient: UserClient
    ) {
        super();
        this.userProfile$ = this.profileService.currentUserProfile$;
    }

    ngOnInit(): void {
        this.isIframe = window !== window.parent && !window.opener;
        this.isHandSet$ = this.breakpointService.isHandset$;
        this.isLoading$ = this.progress.isLoading$;

        this.router.events
            .pipe(
                takeUntil(this.$destroyed),
                filter(events => events instanceof NavigationEnd),
                map(evt => this.activatedRoute),
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                })
            )
            .pipe(
                filter(route => route.outlet === 'primary'),
                mergeMap(route => route.data)
            )
            .subscribe(x => {
                this.showCaseActions = x?.header;
            });
    }

    get userCanSearchCases(): boolean {
        return this.userProfileService.hasAuthorization(Authorize.NonAllocator);
    }

    expandClick(): void {
        this.expandSideMenuClick.emit();
    }

    logout(): void {
        this.authService.logoutRedirect({
            postLogoutRedirectUri: this.envConfig.msalConfig.redirectUri
        });
    }

    getChild(activatedRoute: ActivatedRoute): any {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }

    onProfileClick(): void {
        this.userProfile$.pipe(
            filter(user => user?.roles && user.roles.length > 0),
            take(1),
            mergeMap(profile => {
                return this.userClient.getByAzureId(profile.azureId);
            }),
        )
            .subscribe({
                next: result => {
                    this.router.navigate(['/users', result.user.id]);
                }
            });
    }
}
